import { PropsWithChildren } from 'react';

import { createStore, Provider } from 'jotai';

export const globalStore = createStore();

export const StoreProvider = ({ children }: PropsWithChildren) => <Provider store={globalStore}>{children}</Provider>;
